var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.1031 3.50938L7.74063 0.146875C7.64688 0.053125 7.52031 0 7.3875 0H0.75C0.473437 0 0.25 0.223437 0.25 0.5V13.5C0.25 13.7766 0.473437 14 0.75 14H10.75C11.0266 14 11.25 13.7766 11.25 13.5V3.86406C11.25 3.73125 11.1969 3.60313 11.1031 3.50938ZM10.0969 4.09375H7.15625V1.15313L10.0969 4.09375ZM10.125 12.875H1.375V1.125H6.09375V4.5C6.09375 4.67405 6.16289 4.84097 6.28596 4.96404C6.40903 5.08711 6.57595 5.15625 6.75 5.15625H10.125V12.875Z",
    fill: "{props.fill}"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentNew);
export default __webpack_public_path__ + "static/media/document-new.6300cb23.svg";
export { ForwardRef as ReactComponent };